module.exports = __webpack_public_path__ + "assets/e497a98d370dbc31b06888e74df1d3e5.mp4";